import {
  EMAIL_VERIFICATION_REQUEST,
  EMAIL_VERIFICATION_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_RESET
} from '../constants/emailVerificationConstants';

export const emailVerificationRequest = () => ({
  type: EMAIL_VERIFICATION_REQUEST
});

export const emailVerificationSuccess = (message) => ({
  type: EMAIL_VERIFICATION_SUCCESS,
  payload: message
});

export const emailVerificationFailure = (error) => ({
  type: EMAIL_VERIFICATION_FAILURE,
  payload: error
});

export const emailVerificationReset = () => ({
  type: EMAIL_VERIFICATION_RESET
});

export const verifyEmail = (token, email) => ({
  type: 'EMAIL_VERIFICATION_SAGA',
  payload: { token, email }
});

export const verifyAdminEmail = (token, email) => ({
  type: 'ADMIN_EMAIL_VERIFICATION_SAGA',
  payload: { token, email }
});